import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { testimonials } from "@/data";
import { fadeUp, stagger, viewport } from "@/lib/motion";

const Testimonials = () => {
  return (
    <section className="py-24 md:py-32 bg-[#0a0a0a] border-y border-white/10" data-testid="testimonials">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <motion.h2 variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} className="font-display font-black tracking-tighter text-4xl md:text-5xl lg:text-6xl leading-tight mb-14 max-w-3xl">
          Real businesses. <span className="text-[#ccff00]">Live by Friday.</span>
        </motion.h2>

        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <motion.figure key={t.name} variants={fadeUp} className="rounded-2xl bg-[#121212] border border-white/10 p-8 flex flex-col" data-testid={`testimonial-${t.name.split(" ")[0].toLowerCase()}`}>
              <div className="flex gap-1 mb-5 text-[#ccff00]">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" />)}
              </div>
              <blockquote className="text-zinc-200 leading-relaxed flex-1">"{t.quote}"</blockquote>
              <figcaption className="mt-6 pt-6 border-t border-white/10">
                <span className="font-display font-bold block">{t.name}</span>
                <span className="text-sm text-zinc-500">{t.role}</span>
              </figcaption>
            </motion.figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
